import React from "react";

import { faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Skeleton } from "@performyard/py-components";
import type { ICellRendererParams } from "@performyard/py-components";

import { isLoadingRow } from "./types";
import type { SuperRowContext } from "./types";

export const SUPER_ROW_CARET_TESTID = "competency-super-row-caret";

// Minimal shape shared by every SuperRow-enabled table's row, regardless of which surface's concrete
// row type it wraps.
type CaretCellRow = {
	_rowId: string;
	competency_id?: string;
};

export const CaretCell = (params: ICellRendererParams<CaretCellRow>): React.ReactElement | null => {
	const row = params.data;
	if (!row) return null;
	if (isLoadingRow(row)) return <Skeleton className="size-4 rounded-full" />;

	const context = params.context as SuperRowContext | undefined;
	if (!context) return null;

	const isExpanded = context.expandedRowId === row._rowId;

	return (
		<button
			type="button"
			data-testid={SUPER_ROW_CARET_TESTID}
			aria-label={isExpanded ? "Collapse row" : "Expand row"}
			className="flex h-full w-full cursor-pointer items-center justify-start border-none bg-transparent py-0 pr-0 pl-4"
			onClick={() => context.onExpandToggle(row._rowId)}
		>
			<FontAwesomeIcon
				icon={faCaretDown}
				className={`transition-transform ${isExpanded ? "rotate-180 text-primary-5" : "text-neutral-6"}`}
			/>
		</button>
	);
};
